module.exports = __webpack_public_path__ + "img/ic-default-avatar.0633f656.svg";